import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue'
import router from './router'
import store from './store'
import { baiduAK } from './utils/config'

Vue.config.productionTip = false

// 导入屏幕适配js
import './utils/flexible'

// 导入字体图标
import './styles/iconfont.css'

// 导入全局样式组件
import './styles/global.scss'
import urls from "./utils/url.js"
// 导入element-ui组件
import './register-element'
// 引入vue-resource
import VueResource from 'vue-resource'

// 使用vue-resource
Vue.use(VueResource)
Vue.use(ElementUI);
// 使用百度地图AK
Vue.prototype.$ak = baiduAK
Vue.prototype.url=urls
new Vue({
  router,
  store,
	el: '#app',
  render: (h) => h(App)
}).$mount('#app')
